import Glide from "@glidejs/glide";
import { getElements, getElement, ifSelectorExist } from "./utils";

function GlideAutoHeight(Glide, Components, Events) {
  const Component = {
    mount() {
      if (!Glide.settings.autoHeight) return;
      Components.Html.track.style.transition = "height 200ms ease-in-out";
      this.updateTrackHeight();
    },

    updateTrackHeight() {
      if (!Glide.settings.autoHeight) return;

      const activeSlides = Components.Html.slides.filter((slide, index) => {
        return (
          index >= Glide.index &&
          index <= Glide.index - 1 + Glide.settings.perView
        );
      });

      const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
        return Math.max(maxHeight, slide.offsetHeight);
      }, 0);

      const glideTrack = Components.Html.track;
      if (newMaxHeight !== glideTrack.offsetHeight) {
        glideTrack.style.height = `${newMaxHeight}px`;
      }
    },
  };

  Events.on("run", () => {
    Component.updateTrackHeight();
  });
  Events.on("update", () => {
    Component.updateTrackHeight();
  });
  Events.on("resize", () => {
    Component.updateTrackHeight();
  });

  return Component;
}

export const hvacSliders = () => {
  const coupons_glide = ".coupons_glide";
  if (ifSelectorExist(coupons_glide)) {
    Array.from(getElements(coupons_glide)).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "slider",
        animationDuration: 1000,
        autoplay: 0,
      }).mount();
    });
  }

  const grSlider = ".google_reviews_slider";
  if (ifSelectorExist(grSlider) && document.querySelector(grSlider) !== null) {
    let reviewsSliderPerView = parseInt(
      document.querySelector(grSlider).getAttribute("data-per-view")
    );

    if (isNaN(reviewsSliderPerView)) {
      reviewsSliderPerView = 3;
    }

    Array.from(getElements(grSlider)).forEach((item) => {
      new Glide(item, {
        perView: reviewsSliderPerView,
        type: "carousel",
        slideWidth: 1020,
        breakpoints: {
          1100: {
            perView: reviewsSliderPerView > 1 ? reviewsSliderPerView - 1 : 1,
          },
          768: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const kenbBurnsSlider = ".banner_ken_burns_slider";
  if (ifSelectorExist(kenbBurnsSlider)) {
    Array.from(getElements(kenbBurnsSlider)).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "carousel",
        // animationDuration: 6000,
        animationTimingFunc: "cubic-bezier(100, 100, 100, 100)",
        autoplay: 10000,
      }).mount();
    });
  }

  const videosSlider = ".videos_slider";
  if (ifSelectorExist(videosSlider)) {
    Array.from(getElements(videosSlider)).forEach((item) => {
      new Glide(item, {
        perView: 3,
        type: "carousel",
        breakpoints: {
          1200: {
            perView: 2,
          },
          768: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const mobileReviewsSlider = ".mobile_reviews_slider";
  if (ifSelectorExist(mobileReviewsSlider)) {
    Array.from(getElements(mobileReviewsSlider)).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "carousel",
        breakpoints: {
          768: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const mobileDealersSlider = ".mobileDealersSlider";
  if (ifSelectorExist(mobileDealersSlider)) {
    Array.from(getElements(mobileDealersSlider)).forEach((item) => {
      new Glide(item, {
        perView: 4,
        type: "carousel",
        animationDuration: 1000,
        autoplay: 0,
      }).mount();
    });
  }
};

